import type { MultiSelectOption } from '@/components/MultiSelectFilter'

const PACKAGE_MONTH_LABELS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
] as const

export function reportMonthLabel(reportMonth: string): string {
  const [year, monthPart] = reportMonth.split('-')
  const monthIndex = Number(monthPart) - 1
  const label = PACKAGE_MONTH_LABELS[monthIndex]
  return label && year ? `${label} ${year}` : reportMonth
}

export function dateToReportMonth(date: string | null | undefined): string | null {
  if (!date || date.length < 7) return null
  return date.slice(0, 7)
}

export function collectUploadsMonths(sources: {
  whReportMonths: (string | null | undefined)[]
  productInvoiceDates: (string | null | undefined)[]
  billingReportMonths: (string | null | undefined)[]
  qboTxnDates: (string | null | undefined)[]
}): string[] {
  const months = new Set<string>()
  for (const month of sources.whReportMonths) {
    if (month) months.add(month)
  }
  for (const date of sources.productInvoiceDates) {
    const month = dateToReportMonth(date)
    if (month) months.add(month)
  }
  for (const month of sources.billingReportMonths) {
    if (month) months.add(month)
  }
  for (const date of sources.qboTxnDates) {
    const month = dateToReportMonth(date)
    if (month) months.add(month)
  }
  return Array.from(months).sort()
}

export function buildUploadsMonthOptions(months: string[]): MultiSelectOption[] {
  return months.map((id) => ({ id, label: reportMonthLabel(id) }))
}

export function matchesUploadsMonthFilter(
  month: string | null | undefined,
  selectedMonths: string[]
): boolean {
  if (selectedMonths.length === 0) return true
  if (!month) return false
  return selectedMonths.includes(month)
}

export function pruneInvalidUploadsMonths(
  selectedMonths: string[],
  availableMonths: string[]
): string[] {
  if (availableMonths.length === 0) return []
  const available = new Set(availableMonths)
  return selectedMonths.filter((month) => available.has(month))
}

export function defaultUploadsMonthSelection(availableMonths: string[]): string[] {
  const latest = availableMonths.at(-1)
  return latest ? [latest] : []
}
